/**
 * Таблиці з горизонтальним скролом (core/table): коли праворуч є ще вміст,
 * вішаємо .has-more-right — CSS показує легкий градієнт-підказку.
 */
export default function tableScroll() {
  document.querySelectorAll('.wp-block-table').forEach((el) => {
    const update = () => {
      const more = el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
      el.classList.toggle('has-more-right', more);
    };
    el.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(el);
    update();
  });
}
